import React, { useState, useEffect } from 'react';

import { ContractorAttendanceSOPAddStep1 } from './ContractorAttendanceSOPAddStep1';
import { ContractorAttendanceSOPAddStep2 } from './ContractorAttendanceSOPAddStep2';
import { SingleButton } from '../../Res/BaseButton';


export function ContractorAttendanceSOPAdd({ id, setIsLoading}) {
  const [tokenId, setTokenId] = useState("")
  const [step, setStep] = useState(1)
  const [content, setContent] = useState(<></>)

  const [customerContract, setCustomerContract] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")


  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      setTokenId(id)
    }
  }, [id])

  useEffect(()=>{
    switch (step) {
      case 1:
        setContent(<ContractorAttendanceSOPAddStep1 id={id} setIsLoading={setIsLoading} action={choose} />)
        break;
      case 2:
        setContent(<ContractorAttendanceSOPAddStep2 id={id} item={customerContract} sd={startDate} ed={endDate} setIsLoading={setIsLoading} action={init} />)
        break;
    
      default:
        setContent(<></>)
        break;
    }
  },[step])

  function init(){
    setStep(1)
    setCustomerContract({})
  }

  function choose(item, startDate, endDate){
    setStep(2)
    setCustomerContract(item)
    setStartDate(startDate)
    setEndDate(endDate)
  }



  return (
    <>
      {content}
    </>
  )
}

